import React, { useState, useEffect } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';
import { useSport } from '../contexts/SportContext';
import './SportArcSlider.css';

const SportArcSlider = ({ onSelect }) => {
    const { sportTypes } = useSport();
    const sportArray = Object.values(sportTypes);
    const [activeIndex, setActiveIndex] = useState(0);
    const x = useMotionValue(0);
    const springX = useSpring(x, { stiffness: 300, damping: 40 });
    const CARD_WIDTH = 180; // width + gap

    useEffect(() => {
        onSelect(sportArray[activeIndex].key);
    }, [activeIndex, onSelect, sportArray]);

    const handleDragEnd = (event, info) => {
        const offset = info.offset.x;
        const velocity = info.velocity.x;
        const newIndex = Math.round((x.get() + offset + velocity * 0.2) / -CARD_WIDTH);
        const constrainedIndex = Math.max(0, Math.min(newIndex, sportArray.length - 1));
        x.set(-constrainedIndex * CARD_WIDTH);
        setActiveIndex(constrainedIndex);
    };

    return (
        <div className="arc-slider-container">
            <motion.div className="arc-slider-track" drag="x" dragConstraints={{ right: 0, left: -(sportArray.length - 1) * CARD_WIDTH }} style={{ x: springX }} onDragEnd={handleDragEnd}>
                {sportArray.map((sport, index) => (
                    <Card sport={sport} key={sport.key} isActive={index === activeIndex} />
                ))}
            </motion.div>
        </div>
    );
};

const Card = ({ sport, isActive }) => {
    return (
        <motion.div className="arc-card" animate={{ scale: isActive ? 1.1 : 0.85, y: isActive ? -10 : 0, borderColor: isActive ? '#007BFF' : '#444' }} transition={{ type: "spring", stiffness: 100, damping: 15 }}>
            <div className="arc-emoji">{sport.icon}</div>
            <div className="arc-name">{sport.name}</div>
        </motion.div>
    );
};

export default SportArcSlider;
